import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-lg text-foreground-900 mb-4">第一次的人妻</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              为每一位初为人妻的女性提供角色适应、家庭经营、夫妻沟通与自我成长的实用指南，陪伴你从容迈入婚姻新阶段。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-foreground-900 mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-foreground-900 mb-4 text-sm">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-foreground-900 mb-4 text-sm">关注我们</h4>
            <p className="text-sm text-foreground-600 mb-3">
              每周更新婚姻经营与自我成长内容，陪伴你的每一步。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 hover:bg-accent-200 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 第一次的人妻 · 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors">关于我们</Link>
            <span>·</span>
            <span>用心经营婚姻，温柔对待自己</span>
          </div>
        </div>
      </div>
    </footer>
  );
}